// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"142":"fea7f5c7","340":"038d8c5b"}[chunkId] + ".js";
};